"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatioBox = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var RatioBox_st_css_1 = require("./RatioBox.st.css");
function getCSSVariables(_a) {
    var _b = _a.width, width = _b === void 0 ? 'auto' : _b, _c = _a.height, height = _c === void 0 ? 'auto' : _c;
    return {
        '--width': width,
        '--height': height,
    };
}
exports.RatioBox = function (_a) {
    var _b = _a.ratio, ratio = _b === void 0 ? 1 : _b, width = _a.width, height = _a.height, children = _a.children;
    var x = 100; // to minimise floating point inaccuracy
    var y = x / ratio;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: getCSSVariables({ width: width, height: height }), className: RatioBox_st_css_1.st(RatioBox_st_css_1.classes.ratio, 'ratio') },
            React.createElement("svg", { viewBox: "0 0 " + x + " " + y, version: "1.1", className: RatioBox_st_css_1.st(RatioBox_st_css_1.classes.ratioElement) }),
            React.createElement("div", { className: RatioBox_st_css_1.st(RatioBox_st_css_1.classes.children) }, children))));
};
//# sourceMappingURL=RatioBox.js.map